module.exports = __webpack_public_path__ + "nc_static/media/merck-logo.ec9ed1bc.png";